
import Vue from "vue";
import { mapState } from "vuex";
export default Vue.extend({
  props: {
    isTvp: Boolean,
  },
  data: () => {
    return {};
  },
  computed: {
    ...mapState({
      businessYear: (state: any) =>
        state.disposerManagement.notification.businessYear,
    }),
  },
});
